import { render, staticRenderFns } from "./ModalConfirmEditCarga.vue?vue&type=template&id=2f556660"
import script from "./ModalConfirmEditCarga.vue?vue&type=script&lang=ts"
export * from "./ModalConfirmEditCarga.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports